import React from 'react';
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import Home from '@/containers/Home';
import Game from '@/containers/Game';
import theme from '@/styles/theme';

// Analtyics
ReactGA.initialize(process.env.REACT_APP_ANALYTICS_ID);
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  return (
    <>
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <Router basename={process.env.PUBLIC_URL}>
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route path='/:season/:gameId' element={<Game />} />
          </Routes>  
        </Router>
      </MuiThemeProvider>
    </>
  );
}

export default App;
